import * as React from 'react';

import * as UI from 'core/ui';

import { Res } from 'core/api';
import { Button, Col, Cols, Flex } from 'core/ui';
import { ValueButtonGrid } from 'pos/ui';

import CloseDocumentScreen, { State, PaymentsList, ErrorMessage } from './ShowCloseDocumentScreen.Common';

function PaymentStatus({ status }: { status: State }) {
	return <>
		<Cols className='font-extra-bold'>
			<Col width='*'>
				{Res.Web.CLOSE_TICKET_TOTAL_LBL_2()}
			</Col>
			<Col className='text-right m-r' width='*'>
				{UI.Format.asMoney(status.AmountToPay)}
			</Col>
			<Col width='*'>
				{Res.Web.CLOSE_TICKET_PENDING_LBL_2()}
			</Col>
			<Col className='text-right m-r' width='*'>
				{UI.Format.asMoney(status.PendingAmount)}
			</Col>
		</Cols>
		<Cols>
			<Col width='*'>
				{Res.Web.CLOSE_TICKET_PAID_LBL()}
			</Col>
			<Col className='text-right m-r' width='*'>
				{UI.Format.asMoney(status.PaidAmount)}
			</Col>
			<Col width='*'>
				{Res.Web.CLOSE_TICKET_CHANGE_LBL_2()}
			</Col>
			<Col className='text-right m-r' width='*'>
				{UI.Format.asMoney(status.ChangeAmount)}
			</Col>
		</Cols>
	</>;
}

export default class PhoneCloseDocumentScreen extends CloseDocumentScreen {

	protected getContent(): React.ReactNode {
		const { PriceBox } = UI.controlsFor<State>();

		return (
			<Flex.Vertical>
				<Flex.Item className='border-bottom'>
					<PaymentStatus status={this.state} />
					<Cols key={this.state.proposedAmountKey} className='m-t'>
						<Col className='text-right' width='*'>
							<PriceBox placeholder={Res.Web.CLOSE_TICKET_PAID_LBL()} ref={this.txtIntroducedAmount} linkTo={x => x.CurrentPaidAmount} boundValue={this.state.CurrentPaidAmount || null}
								onKeyDown={UI.whenEnterKey(() => this.txtIntroducedTip.current!.activate())} />
						</Col>
						<Col className='text-center'>
							<Button onClick={this.onSetTip}><i className='fa fa-arrow-right text-info' /></Button>
						</Col>
						<Col className='text-right' width='*'>
							<PriceBox placeholder={Res.Web.CLOSE_TICKET_TIP_LBL()} ref={this.txtIntroducedTip} linkTo={x => x.CurrentTipAmount} boundValue={this.state.CurrentTipAmount || null} />
						</Col>
					</Cols>
					<ErrorMessage errorMsg={this.state.ErrorMessage} />

					<ValueButtonGrid rows={1} values={this.props.paymentOperation.Methods} onValueSelected={this.onPaymentMethodSelected} />
				</Flex.Item>
				<Flex.Item size='*'>
					<PaymentsList payments={this.state.Payments} selectedPaymentIndex={this.state.SelectedMethod} onSelect={this.onSelectPayment} onAddNote={this.onAddNote} onRemove={this.onRemovePayment} />
				</Flex.Item>
			</Flex.Vertical>
		);
	}
}
